import React, { useState, useEffect } from 'react';
import './TopBar.css';

const TopBar = ({ onToggleMenu, isTourActive }) => {
  const [time, setTime] = useState(new Date());
  const [ipAddress, setIpAddress] = useState('10.13.42.7');
  const [latency, setLatency] = useState('18ms');
  const [ping, setPing] = useState(18);

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const newPing = Math.floor(Math.random() * 20) + 12;
      setPing(newPing);
      setLatency(`${newPing}ms`);
      setIpAddress(`10.13.${Math.floor(Math.random() * 255)}.42`);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = () =>
    time.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });

  const formatDate = () =>
    time.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: '2-digit' });

  // Signal strength bars based on ping
  const signalLevel = ping < 20 ? 4 : ping < 30 ? 3 : ping < 40 ? 2 : 1;

  return (
    <div className={`topbar-wrapper ${isTourActive ? 'tour-active' : ''}`}>
      <div className="topbar-pill">

        {/* Left: Menu + Branding */}
        <div className="topbar-left">
          <button className="topbar-menu-btn" onClick={onToggleMenu} aria-label="Menu">
            <span className="menu-line"></span>
            <span className="menu-line"></span>
            <span className="menu-line"></span>
          </button>
          <div className="topbar-brand">
            <span className="brand-prompt">root@</span>
            <span className="brand-host">diptanshu</span>
            <span className="brand-separator">·</span>
            <span className="brand-online-dot"></span>
          </div>
        </div>

        {/* Divider */}
        <div className="topbar-divider" />

        {/* Right: Stats */}
        <div className="topbar-right">

          {/* Signal / Network */}
          <div className="topbar-stat" title={`IP: ${ipAddress} · Latency: ${latency}`}>
            <div className="signal-bars">
              {[1, 2, 3, 4].map(i => (
                <span
                  key={i}
                  className="signal-bar"
                  style={{ opacity: i <= signalLevel ? 1 : 0.2, height: `${4 + i * 3}px` }}
                />
              ))}
            </div>
            <span className="topbar-stat-value">{latency}</span>
          </div>

          <div className="topbar-dot-sep" />

          {/* IP */}
          <div className="topbar-stat">
            <span className="topbar-stat-icon">◈</span>
            <span className="topbar-stat-value ip-value">{ipAddress}</span>
          </div>

          <div className="topbar-dot-sep" />

          {/* Date */}
          <div className="topbar-stat">
            <span className="topbar-stat-value date-value">{formatDate()}</span>
          </div>

        {/* Center: Clock absolutely centered */}
        <div className="topbar-center">
          <span className="topbar-clock-value">{formatTime()}</span>
        </div>

          {/* Status indicator */}
          <div className="topbar-status-pill">
            <span className="topbar-status-dot"></span>
            <span className="topbar-status-text">LIVE</span>
          </div>

        </div>
      </div>
    </div>
  );
};

export default TopBar;
